module.exports = __webpack_public_path__ + "static/media/maf-06.1892e225.png";